import { useQuery } from "@apollo/client";
import {
  GET_CAR_OWNER_BY_ID,
  GET_OWNER_CARS,
  GET_PRICELIST,
  GET_PRODUCTS,
  GET_CAR_OWNERS,
} from "../../graphql/AdminQueries";

const tokenGet = process.env.REACT_APP_TOKEN_GET;

/**
 * Nacita jedneho majitela podla id. Dopyt getCarOwners(id:) vracia ZOZNAM
 * s jednym prvkom, nie jeden objekt. Kym sa tu citalo data.getCarOwner
 * (jednotne cislo), bolo to vzdy undefined a kazde otvorenie detailu
 * tahalo zalozny dopyt na vsetkych 531 majitelov.
 */
export function useCarOwnerById(ownerId, loadData) {
  const byId = useQuery(GET_CAR_OWNER_BY_ID, {
    variables: { ownerId: String(ownerId), tokenGet },
    skip: !ownerId || !loadData,
  });
  const najdeny = byId.data?.getCarOwners;
  const prvy = Array.isArray(najdeny) ? najdeny[0] : najdeny;
  const needFallback = !byId.loading && (byId.error || !prvy) && ownerId;
  const allOwners = useQuery(GET_CAR_OWNERS, {
    variables: { tokenGet },
    skip: !ownerId || !loadData || !needFallback,
  });
  const ownerFromId = prvy;
  const ownersList = allOwners.data?.getCarOwners;
  const ownerFromList =
    Array.isArray(ownersList) &&
    ownersList.find((o) => String(o?.id) === String(ownerId));
  const owner = ownerFromId || ownerFromList;
  const loading =
    byId.loading || (needFallback && allOwners.loading && !ownerFromList);
  const error =
    byId.error && !ownerFromList && !allOwners.loading ? byId.error : null;
  return {
    owner,
    loading,
    error,
    refetch: byId.refetch,
  };
}

/**
 * Fetches cars for a specific owner.
 */
export function useOwnerCars(ownerId, loadData) {
  const result = useQuery(GET_OWNER_CARS, {
    variables: {
      carOwnerId: ownerId,
      tokenGet,
    },
    skip: !ownerId || !loadData,
  });
  const cars = result.data?.getCars;
  return {
    ...result,
    cars: Array.isArray(cars) ? cars : [],
  };
}

/**
 * Fetches pricelist for a specific owner.
 */
export function useOwnerPricelist(ownerId, loadData) {
  const result = useQuery(GET_PRICELIST, {
    variables: {
      carOwner: ownerId,
      tokenGet,
    },
    skip: !ownerId || !loadData,
  });
  const pricelist = result.data?.getPricelist;
  return {
    ...result,
    pricelist: Array.isArray(pricelist)
      ? pricelist
      : pricelist
      ? [pricelist]
      : [],
  };
}

/**
 * Fetches products (for price list tab). Only used on detail page.
 */
export function useOwnerProducts(ownerId, loadData) {
  const result = useQuery(GET_PRODUCTS, {
    variables: {
      tokenGet,
      offset: 0,
      limit: 50000,
      search: undefined,
    },
    skip: !ownerId || !loadData,
  });
  const items = result.data?.getProducts?.items;
  return {
    ...result,
    products: Array.isArray(items) ? items : [],
  };
}
